<template>
  <v-card class="mx-auto" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col cols="12" md="8">
          <BtnCircle
            tLabel="Atrás"
            tPosition="bottom"
            icon="mdi-arrow-left"
            color="grey darken-3"
            size="x-small"
            :to="{
              name: 'contratantes',
            }"
          />
          <span
            class="text-h6 ml-1"
            v-text="
              `${$route.meta.title} ${
                data && data.length == 0 ? '' : ` (${data.length})`
              }`
            "
          />
        </v-col>
        <v-col cols="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="info"
                @click.stop="faqs_dlg = true"
                :loading="faqs_ldg"
                :disabled="faqs.length == 0"
              >
                <v-icon> mdi-help </v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>
          <v-tooltip v-if="login.role_id == 1" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="teal"
                :loading="btn_xls_ldg"
                :disabled="data.length == 0"
                @click.prevent="downloadXls"
              >
                <v-icon> mdi-table-arrow-down </v-icon>
              </v-btn>
            </template>
            <span v-text="'Descargar tabla XLS'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="4">
          <v-select
            label="Estado"
            v-model="filter"
            :items="filters"
            item-value="id"
            :item-text="(v) => v.name"
            dense
            @change="getTableData"
          />
        </v-col>
        <v-col v-if="data.length > 0" cols="12" md="8">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
            dense
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :loading="loading"
          >
            <template v-slot:item.user_id="{ item }">
              <v-icon
                small
                v-text="item.user_id ? 'mdi-check' : 'mdi-close'"
                :color="item.user_id ? 'success' : ''"
              />
            </template>
            <template v-slot:item.index="{ item, index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.medical_treatment="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    :color="
                      (item.medical_treatment ? 'pink ' : 'grey') + ' darken-1'
                    "
                  >
                    mdi-shield-account
                  </v-icon>
                </template>
                <span
                  v-text="
                    (item.medical_treatment ? 'Con' : 'Sin') +
                    ' Acompañamiento méd.'
                  "
                />
              </v-tooltip>
            </template>
            <template v-slot:item.revision_pending.revision_user="{ item }">
              <div v-if="item.revision_pending" class="text-center">
                <v-icon
                  small
                  :color="
                    item.revision_pending.revision == null
                      ? 'warning'
                      : item.revision_pending.revision &&
                        item.revision_pending.accepted
                      ? 'success'
                      : 'error'
                  "
                >
                  mdi-{{
                    item.revision_pending.revision == null
                      ? "alert"
                      : item.revision_pending.revision &&
                        item.revision_pending.accepted
                      ? "check"
                      : "close"
                  }}
                </v-icon>
                <div v-if="item.revision_pending.revision">
                  <span v-text="item.revision_pending.revision_user" />
                  <br />
                  <small v-text="item.revision_pending.revision_date" />
                </div>
              </div>
              <v-icon v-else small> mdi-alert </v-icon>
            </template>
            <template v-slot:item.revision_pending.confirmation_user="{ item }">
              <div v-if="item.revision_pending" class="text-center">
                <v-icon
                  small
                  :color="
                    item.revision_pending.confirmation == null
                      ? 'warning'
                      : item.revision_pending.confirmation &&
                        item.revision_pending.accepted
                      ? 'success'
                      : 'error'
                  "
                >
                  mdi-{{
                    item.revision_pending.confirmation == null
                      ? "alert"
                      : item.revision_pending.confirmation &&
                        item.revision_pending.accepted
                      ? "check"
                      : "close"
                  }}
                </v-icon>
                <div v-if="item.revision_pending.confirmation">
                  <span v-text="item.revision_pending.confirmation_user" />
                  <br />
                  <small v-text="item.revision_pending.confirmation_date" />
                </div>
              </div>
              <v-icon v-else small> mdi-alert </v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    x-small
                    color="primary"
                    :to="{
                      name: `asegurados.view`,
                      params: {
                        id: item.id,
                        contractor_id: item.contractor_id,
                      },
                    }"
                  >
                    <v-icon v-text="'mdi-eye-outline'" />
                  </v-btn>
                </template>
                <span v-text="'Ver'" />
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  base64ToArrayBuffer,
  dateTimeToFile,
} from "../../control";
import BtnCircle from "../../components/BtnCircle.vue";
import FaqDlg from "../../components/FaqDlg.vue";

export default {
  components: {
    BtnCircle,
    FaqDlg,
  },
  data() {
    return {
      login: this.$store.getters.getLogin,
      loading: false,
      data: [],
      search: "",
      headers: [
        { text: "#", filterable: false, value: "index" },
        { text: "Contratante", filterable: true, value: "contractor.name" },
        { text: "ID SM", filterable: true, value: "enrollment" },
        { text: "Nombre", filterable: true, value: "name" },
        { text: "Apellido paterno", filterable: true, value: "first_surname" },
        { text: "Apellido materno", filterable: true, value: "second_surname" },
        { text: "Póliza", filterable: true, value: "policy" },
        { text: "Vigencia", filterable: true, value: "validity" },
        { text: "Tipo", filterable: true, value: "insured_type.insured_type" },
        {
          text: "R1",
          filterable: true,
          value: "revision_pending.revision_user",
        },
        {
          text: "R2",
          filterable: true,
          value: "revision_pending.confirmation_user",
        },
        { text: "T. méd.", filterable: false, value: "medical_treatment" },
        { text: "Usr. sis.", filterable: false, value: "user_id" },
        { text: "", value: "action", sortable: false },
      ],
      medical_treatment: 0,
      medical_treatments: [
        { id: 0, value: "TODOS" },
        { id: 1, value: "En Acompañamiento méd." },
        { id: 2, value: "Sin Acompañamiento méd." },
      ],
      filter: null,
      filters: [
        { id: null, name: "Selecciona una opción..." },
        { id: 1, name: "REEMBOLSO" },
        { id: 2, name: "REEMBOLSO SIN DATOS BANCARIOS" },
        { id: 3, name: "PENDIENTE REV 1" },
        { id: 4, name: "PENDIENTE REV 2" },
      ],
      btn_xls_ldg: false,
      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
    };
  },
  methods: {
    getTableData() {
      this.data = [];

      this.loading = true;

      Axios.get(
        URL_API + "/insureds/get/all/refound" + "?filter=" + this.filter,
        headersToken(this.login.token)
      ).then((response) => {
        this.data = response.data.data;
        this.loading = false;
      });
    },
    downloadXls() {
      this.btn_xls_ldg = true;

      Axios.post(
        URL_API + "/insureds/xls",
        {
          items: this.data,
        },
        headersToken(this.login.token)
      ).then((res) => {
        if (res.data.success) {
          this.fileDownload(res.data.data, "xlsx", "asegurados");
          this.btn_xls_ldg = false;
        } else {
          this.btn_xls_ldg = false;
          this.$swal.fire(msgAlert("error", "Error al generar archixo XLSX"));
        }
      });
    },
    fileDownload(base64, ext, name) {
      const blob = new Blob([base64ToArrayBuffer(base64)], {
        type: "application/" + ext,
      });
      let downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = "SM_" + name + "_" + dateTimeToFile() + "." + ext;
      downloadLink.click();
    },
  },
  mounted() {
    Axios.get(
      URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
      headersToken(this.login.token)
    ).then((resp) => {
      this.faqs = resp.data.data;
      this.faqs_ldg = false;
    });
  },
};
</script>